<div class="api-dash">
  <h2>API Endpoints</h2>
  <table>
    <thead>
      <tr>
        <th>URL</th>
        <th>Weight</th>
        <th>Active</th>
        <th>Samples</th>
        <th>Avg Duration</th>
        <th>Durations (ms)</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let ep of endpoints">
        <td>{{ ep.url }}</td>
        <td>{{ ep.weight }}</td>
        <td>
          <span [class]="ep.isActive ? 'badge active' : 'badge inactive'">
            {{ ep.isActive ? 'Active' : 'Inactive' }}
          </span>
        </td>
        <td>{{ ep.durations.length }}</td>
        <td>{{ avgDuration(ep.durations) }}</td>
        <td class="durations">{{ ep.durations.join(', ') || '—' }}</td>
      </tr>
    </tbody>
  </table>

  <div class="actions">
    <div class="endpoint-col" *ngFor="let ep of endpoints">
      <div class="endpoint-label">{{ ep.url }}</div>
      <button (click)="loadSystemInfo(ep.url)">Get System Info</button>
      <button (click)="loadDiskSpace(ep.url)">Get Disk Space</button>
      <button (click)="doRestartApi(ep.url)">Restart API</button>
    </div>
  </div>

  <div class="log-area">
    <h3>Output</h3>
    <textarea readonly rows="10" [value]="log"></textarea>
  </div>
</div>
